import { useState } from "react";
import { toast } from "sonner";
import { Check, Copy, Link2 } from "lucide-react";
import { clock } from "../../../lib/dash";

// A one-time link to copy (invite / password reset). Shown once; only its hash is stored, no email is sent.
export const LinkBox = ({ result, testid = "account-link" }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(result.link);
      setCopied(true);
      toast.success("Link copied");
    } catch {
      toast.error("Could not copy. Select the link and copy it by hand.");
    }
  };
  return (
    <div data-testid={testid} className="space-y-2 rounded-xl border border-primary/40 bg-primary/5 p-3">
      <p className="flex items-center gap-1.5 text-[12px] font-semibold">
        <Link2 className="h-3.5 w-3.5" /> {result.purpose === "invite" ? "Invite link" : "Password link"} · single use · expires {clock(result.expires_at)}
      </p>
      <div className="flex items-center gap-2">
        <input readOnly value={result.link} data-testid={`${testid}-value`} onFocus={(e) => e.target.select()}
          className="min-w-0 flex-1 rounded-lg border border-input bg-background px-2 py-1.5 font-mono2 text-[11px]" />
        <button type="button" data-testid={`${testid}-copy`} onClick={copy}
          className="flex shrink-0 items-center gap-1 rounded-full bg-foreground px-3 py-1.5 text-[11px] font-semibold text-background transition-opacity hover:opacity-85">
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />} {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <p className="text-[11px] text-muted-foreground">Nothing was emailed. Send this link to the person yourself; it is shown only now.</p>
    </div>
  );
};
